import { createAsyncAction } from 'typesafe-actions';

import env from '@travel/env';
import { isNotEmptyArray } from '@travel/utils';

import { fetch } from './api';

import type { AppThunk } from 'typesafe-actions';
import type { Banners } from 'Banner-Types';

export const fetchBannerAsync = createAsyncAction(
  'FETCH_BANNER_REQUEST',
  'FETCH_BANNER_SUCCESS',
  'FETCH_BANNER_FAILURE',
)<undefined, Banners, undefined>();

export const fetchBanner = (): AppThunk => async (dispatch, getState, { apiClient }) => {
  const { banner } = getState();
  // do not fetch when data has been fetched
  if (
    !env('UNIVERSAL_BANNER_API_SERVER_URL') ||
    !env('UNIVERSAL_BANNER_API_CLIENT_URL') ||
    isNotEmptyArray(banner?.items)
  )
    return;

  dispatch(fetchBannerAsync.request());
  try {
    const response = await fetch(apiClient);
    dispatch(fetchBannerAsync.success(response));
  } catch (error) {
    dispatch(fetchBannerAsync.failure());
  }
};
